import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m18.807 6.624-.623-1.08a1.913 1.913 0 0 0-2.609-.705 1.904 1.904 0 0 1-2.608-.678 1.83 1.83 0 0 1-.257-.915 1.913 1.913 0 0 0-1.913-1.968H9.544A1.904 1.904 0 0 0 7.64 3.191a1.913 1.913 0 0 1-1.913 1.886 1.83 1.83 0 0 1-.916-.256 1.913 1.913 0 0 0-2.608.704l-.669 1.099a1.913 1.913 0 0 0 .696 2.608 1.913 1.913 0 0 1 0 3.314 1.904 1.904 0 0 0-.696 2.6l.632 1.089a1.913 1.913 0 0 0 2.609.741 1.895 1.895 0 0 1 2.6.696c.164.277.252.593.255.915 0 1.057.857 1.913 1.914 1.913h1.253c1.053 0 1.909-.85 1.913-1.904a1.904 1.904 0 0 1 1.914-1.913c.321.009.636.097.915.256a1.913 1.913 0 0 0 2.609-.695l.659-1.098a1.904 1.904 0 0 0-.696-2.61 1.904 1.904 0 0 1-.696-2.608c.166-.29.406-.53.696-.696a1.913 1.913 0 0 0 .696-2.6z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.175 13.525a2.636 2.636 0 1 0 0-5.272 2.636 2.636 0 0 0 0 5.272"
    }, null, -1)
  ])))
}
export default { render: render }